// extracted by mini-css-extract-plugin
export var brand = "_89-9";
export var compact = "_89-6";
export var extraSmall = "_89-7";
export var icon = "_89-0";
export var large = "_89-4";
export var light = "_89-1";
export var medium = "_89-5";
export var outline = "_89-b";
export var primaryDark = "_89-a";
export var primaryLight = "_89-8";
export var primaryModern = "_89-c";
export var success = "_89-2";
export var successSolid = "_89-3";